<template>
  <div class="image-upload-container clearfix">
    <a-upload
      listType="picture-card"
      :action="uploadURL"
      :headers="uploadToken"
      :data="{ root_path: rootPath }"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      @preview="handlePreview"
      :remove="handleRemove"
      @change="handleChange"
    >
      <div v-if="fileList.length < 1">
        <a-icon type="plus" />
        <div class="ant-upload-text">点击上传</div>
      </div>
    </a-upload>
    <a-modal
      :visible="previewVisible"
      @cancel="handlePreviewClose"
      :footer="null"
    >
      <img alt="previewImage" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import config from '@/config/config'

export default {
  name: 'ImageUpload',

  props: {
    rootPath: { type: String },
    value: { type: String }
  },

  mounted() {
    // 设置上传 URL 和 token
    this.uploadURL = `${config.baseURL}/upload`
    this.uploadToken = {
      Authorization: this.$store.state.auth.token
    }
  },

  watch: {
    value(val) {
      if (val) {
        this.fileList = [
          {
            uid: '1',
            name: 'banner.png',
            status: 'done',
            url: val
          }
        ]
      }
    }
  },

  data() {
    return {
      uploadURL: '',
      uploadToken: {},
      fileList: [],
      previewVisible: false,
      previewImage: ''
    }
  },
  methods: {
    // 图片预览
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },

    // 关闭图片预览
    handlePreviewClose() {
      this.previewVisible = false
    },

    // 校验图片格式和大小
    beforeUpload(file) {
      //console.log(file)
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isWEBP = file.type === 'image/webp'
      const isFileLegal = isJPG || isPNG || isWEBP
      if (!isFileLegal) {
        this.$message.error('只能上传 JPG、PNG 或 WEBP 文件!')
      }

      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片不得大于2MB!')
      }

      return isFileLegal && isLt2M
    },

    // 提交
    handleChange(info) {
      let fileList = info.fileList
      let file = info.file
      // if (file.status === 'uploading') {
      // console.log('uploading')
      // }
      // if (file.status === 'done') {
      //   console.log('done')
      // }
      if (file.status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`)
      }
      if (file.status === 'done' && file.response) {
        const res = file.response
        if (res.code === 200) {
          // console.log(file.response)
          // this.$message.success(res.message)
          this.triggerChange(res.data.url)
        } else {
          this.$message.error(`上传失败：${res.message}`)
        }
      }

      this.fileList = fileList
    },

    // 删除
    handleRemove() {
      this.triggerChange(null)
    },

    // 向父组件传递 imageURL
    triggerChange(changedValue) {
      this.$emit('change', changedValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
